const saveTrim = (element) => {
  if (element && typeof element === "string") {
    return element.trim();
  }

  return element;
};

export default saveTrim;
